import { Outlet, ScrollRestoration } from "react-router-dom";
import "./App.css";
import Footer from "./components/layout/footer/footer";
import StyledNavbar from "./components/layout/navbar/navbar";
import {SiteJsonLd} from "./seo/SiteJsonLd";

function App() {
  return (
    <>
      <SiteJsonLd />
      <StyledNavbar />
      <div style={{ minHeight: "100vh" }}>
        <ScrollRestoration/>
        <Outlet />
      </div>
      <Footer />
    </>
  );
}

export default App;
